/**
 * Límite de tamaño por archivo (en MB). Fuente única: media.service.controlSize.
 */
export { MAX_ARCHIVO_MB } from '@services/shared/media.service';

/**
 * Formatos aceptados para la subida de documentación.
 * El backend convierte HEIC/HEIF a WebP al recibirlos.
 */
export const ACCEPT_ARCHIVOS =
    'application/pdf, image/jpeg, image/jpg, image/png, image/heic, image/heif';

/**
 * Placeholder (SVG inline) para el preview de archivos HEIC/HEIF:
 * Chrome/Edge no los decodifican, por lo que no se puede generar una miniatura real.
 */
export const PLACEHOLDER_HEIC =
    'data:image/svg+xml;charset=utf-8,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
            '<rect width="100" height="100" fill="#f1f5f9"/>' +
            '<path d="M22 22h56v56H22z" fill="none" stroke="#B1476A" stroke-width="4"/>' +
            '<circle cx="40" cy="42" r="7" fill="#4CA7C8"/>' +
            '<path d="M22 74l22-16 14 10 12-14 8 7v13H22z" fill="#4CA7C8"/>' +
            '</svg>'
    );

/**
 * Detecta HEIC/HEIF por MIME o por extensión.
 * Se suben crudos (sin redimensionar): el backend los convierte a WebP.
 */
export function esHeic(file: File | undefined | null): boolean {
    if (!file) {
        return false;
    }
    const tipo = (file.type || '').toLowerCase();
    const esHeicMime =
        tipo === 'image/heic' ||
        tipo === 'image/heif' ||
        tipo === 'image/heic-sequence' ||
        tipo === 'image/heif-sequence';
    return esHeicMime || /\.hei[cf]$/i.test(file.name || '');
}
